import { formatDateTime } from "../../utils/FormateDate"

const AgentOrderTable = ({ agentDetails }) => {

  return (
    <div className="flow-root bg-white rounded-tr-2xl rounded-tl-2xl">
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full divide-y divide-gray-300 table-auto p-4 border">
              <thead className="bg-primaryGray p-1 rounded-t-md rounded-tr-md">
                <tr>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-black">
                    S/N
                  </th>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold capitalize text-black">
                  Order ID
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                  date
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                  food item (Description)
                  </th>
                </tr>
              </thead>
              <tbody>
                { agentDetails && (
                  agentDetails?.agentOrderHistories.map((order, index) => (
                    <tr key={index} className="border-b border-b-primaryGray">
                      <td className="px-3 text-xs text-black capitalize font-medium">{index + 1}</td>
                      <td className="px-3 py-4 text-xs text-black text-center capitalize">{order?.orderCode}</td>
                      <td className="px-3 text-xs text-black whitespace-nowrap capitalize font-medium">{formatDateTime(order?.orderDate)}</td>
                      <td className="px-3 py-4 text-xs text-black text-center capitalize">{order?.foodItems}</td>
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </div>
        </div>
    </div>
  )
}

export default AgentOrderTable